// extracted by mini-css-extract-plugin
export default {"wrapper":"FavoriteIdItem_wrapper__xD1Sv","info":"FavoriteIdItem_info__dqcGx"};